import React from 'react';

const PartyPopper = ({ className }) => {
  return (
    <svg
      width="410"
      height="84"
      viewBox="0 0 410 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_107_84227"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="410"
        height="84"
      >
        <path
          d="M0 20C0 8.9543 8.9543 0 20 0H390C401.046 0 410 8.95431 410 20V84H0V20Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_107_84227)">
        <mask
          id="mask1_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="-9"
          y="-2"
          width="17"
          height="2"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M-8.04105 -0.318813C-8.04105 -0.318813 3.41636 0.138257 6.69315 -0.298731L7.47363 -1.77295C4.19619 -1.33407 -7.26089 -1.79209 -7.26089 -1.79209L-8.04105 -0.318813Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_107_84227)"></g>
        <mask
          id="mask2_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="6"
          y="16"
          width="7"
          height="8"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.00719 19.1465C6.00719 19.1465 7.14736 22.0213 10.1412 23.7576L12.4396 21.0324C9.44581 19.2961 8.3047 16.421 8.3047 16.421L6.00719 19.1465Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask2_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.00719 19.1465C6.00719 19.1465 7.14736 22.0213 10.1412 23.7576L12.4396 21.0324C9.44581 19.2961 8.3047 16.421 8.3047 16.421L6.00719 19.1465Z"
            fill="url(#paint0_linear_107_84227)"
          />
        </g>
        <mask
          id="mask3_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="19"
          y="-3"
          width="5"
          height="4"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.3373 -1.68127L19.9248 0.371883C19.9248 0.371883 21.9062 0.558084 23.9859 -0.610479L23.3983 -2.66363C21.3199 -1.49569 19.3373 -1.68127 19.3373 -1.68127Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask3_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.3373 -1.68127L19.9248 0.371883C19.9248 0.371883 21.9062 0.558084 23.9859 -0.610479L23.3983 -2.66363C21.3199 -1.49569 19.3373 -1.68127 19.3373 -1.68127Z"
            fill="url(#paint1_linear_107_84227)"
          />
        </g>
        <mask
          id="mask4_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="94"
          y="16"
          width="14"
          height="6"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M94.8172 20.167C94.8172 20.167 103.156 21.7619 107.044 20.7155L107.248 16.6326C103.36 17.6799 95.0213 16.0851 95.0213 16.0851L94.8172 20.167Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask4_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M94.8172 20.167C94.8172 20.167 103.156 21.7619 107.044 20.7155L107.248 16.6326C103.36 17.6799 95.0213 16.0851 95.0213 16.0851L94.8172 20.167Z"
            fill="url(#paint2_linear_107_84227)"
          />
        </g>
        <mask
          id="mask5_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="118"
          y="31"
          width="7"
          height="6"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M118.715 34.0154C118.715 34.0154 120.114 35.9121 122.906 36.5901L124.435 34.1055C121.643 33.4275 120.244 31.5307 120.244 31.5307L118.715 34.0154Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask5_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M118.715 34.0154C118.715 34.0154 120.114 35.9121 122.906 36.5901L124.435 34.1055C121.643 33.4275 120.244 31.5307 120.244 31.5307L118.715 34.0154Z"
            fill="url(#paint3_linear_107_84227)"
          />
        </g>
        <mask
          id="mask6_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="26"
          y="27"
          width="6"
          height="6"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M26.331 30.8379L28.0826 32.6711C28.0826 32.6711 30.0775 31.964 31.3793 29.8296L29.628 27.9955C28.3262 30.13 26.331 30.8379 26.331 30.8379Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask6_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M26.331 30.8379L28.0826 32.6711C28.0826 32.6711 30.0775 31.964 31.3793 29.8296L29.628 27.9955C28.3262 30.13 26.331 30.8379 26.331 30.8379Z"
            fill="url(#paint4_linear_107_84227)"
          />
        </g>
        <mask
          id="mask7_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="74"
          y="34"
          width="8"
          height="10"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M74.9444 35.3562C74.9444 35.3562 77.6452 41.7953 80.353 43.2596L81.4226 41.9071C78.7145 40.4437 76.014 34.0037 76.014 34.0037L74.9444 35.3562Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask7_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M74.9444 35.3562C74.9444 35.3562 77.6452 41.7953 80.353 43.2596L81.4226 41.9071C78.7145 40.4437 76.014 34.0037 76.014 34.0037L74.9444 35.3562Z"
            fill="url(#paint5_linear_107_84227)"
          />
        </g>
        <mask
          id="mask8_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="79"
          y="-9"
          width="6"
          height="10"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M79.3416 -1.06141L80.7868 0.153304C80.7868 0.153304 84.1052 -4.33593 84.9338 -7.51328L83.4885 -8.72799C82.659 -5.55097 79.3416 -1.06141 79.3416 -1.06141Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask8_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M79.3416 -1.06141L80.7868 0.153304C80.7868 0.153304 84.1052 -4.33593 84.9338 -7.51328L83.4885 -8.72799C82.659 -5.55097 79.3416 -1.06141 79.3416 -1.06141Z"
            fill="url(#paint6_linear_107_84227)"
          />
        </g>
        <mask
          id="mask9_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="54"
          y="2"
          width="7"
          height="6"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M54.7132 3.73721C54.7132 3.73721 55.1367 5.91999 57.4393 7.61499L60.0376 6.0983C57.736 4.40362 57.3116 2.22052 57.3116 2.22052L54.7132 3.73721Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask9_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M54.7132 3.73721C54.7132 3.73721 55.1367 5.91999 57.4393 7.61499L60.0376 6.0983C57.736 4.40362 57.3116 2.22052 57.3116 2.22052L54.7132 3.73721Z"
            fill="url(#paint7_linear_107_84227)"
          />
        </g>
        <mask
          id="mask10_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="64"
          y="17"
          width="7"
          height="6"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M64.9359 20.512C64.9359 20.512 66.7484 22.1958 69.6442 22.2664L70.5638 19.2854C67.6687 19.2129 65.8558 17.53 65.8558 17.53L64.9359 20.512Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask10_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M64.9359 20.512C64.9359 20.512 66.7484 22.1958 69.6442 22.2664L70.5638 19.2854C67.6687 19.2129 65.8558 17.53 65.8558 17.53L64.9359 20.512Z"
            fill="url(#paint8_linear_107_84227)"
          />
        </g>
        <mask
          id="mask11_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="43"
          y="31"
          width="5"
          height="7"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M43.3124 33.101C43.3124 33.101 43.6608 35.3479 45.4135 37.2026L47.3441 35.8007C45.5914 33.9461 45.2433 31.6982 45.2433 31.6982L43.3124 33.101Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask11_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M43.3124 33.101C43.3124 33.101 43.6608 35.3479 45.4135 37.2026L47.3441 35.8007C45.5914 33.9461 45.2433 31.6982 45.2433 31.6982L43.3124 33.101Z"
            fill="url(#paint9_linear_107_84227)"
          />
        </g>
        <mask
          id="mask12_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="12"
          y="58"
          width="7"
          height="6"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.6937 61.0756L14.2602 63.4616C14.2602 63.4616 16.4558 62.9886 18.1339 60.769L16.5677 58.3821C14.8896 60.6017 12.6937 61.0756 12.6937 61.0756Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask12_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.6937 61.0756L14.2602 63.4616C14.2602 63.4616 16.4558 62.9886 18.1339 60.769L16.5677 58.3821C14.8896 60.6017 12.6937 61.0756 12.6937 61.0756Z"
            fill="url(#paint10_linear_107_84227)"
          />
        </g>
        <mask
          id="mask13_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="51"
          width="7"
          height="7"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.996846 55.8361L3.68326 57.4147C3.68326 57.4147 5.60266 55.7996 6.17146 52.701L3.48475 51.1201C2.91595 54.2188 0.996846 55.8361 0.996846 55.8361Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask13_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.996846 55.8361L3.68326 57.4147C3.68326 57.4147 5.60266 55.7996 6.17146 52.701L3.48475 51.1201C2.91595 54.2188 0.996846 55.8361 0.996846 55.8361Z"
            fill="url(#paint11_linear_107_84227)"
          />
        </g>
        <mask
          id="mask14_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="35"
          y="9"
          width="10"
          height="7"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M35.0759 13.3285C35.1717 13.3636 37.0632 14.6737 37.2931 14.7095C37.4466 14.8597 39.6581 15.7597 39.8989 15.61C42.1378 14.8886 44.7215 11.0401 44.4566 9.61941C44.3636 9.87402 40.8202 9.67558 40.7573 9.48047C40.5905 10.8339 37.2668 13.4282 35.0759 13.3285Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask14_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M35.0759 13.3285C35.1717 13.3636 37.0632 14.6737 37.2931 14.7095C37.4466 14.8597 39.6581 15.7597 39.8989 15.61C42.1378 14.8886 44.7215 11.0401 44.4566 9.61941C44.3636 9.87402 40.8202 9.67558 40.7573 9.48047C40.5905 10.8339 37.2668 13.4282 35.0759 13.3285Z"
            fill="url(#paint12_linear_107_84227)"
          />
        </g>
        <mask
          id="mask15_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="-11"
          y="16"
          width="12"
          height="22"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M-10.6315 24.9488C-11.1454 25.2033 -10.5519 30.6979 -10.5384 31.2208C-10.5259 31.6883 -9.93902 37.3033 -10.3099 37.4866C-5.93355 35.3214 -2.26896 32.3115 0.571015 28.5481C0.741798 28.3224 0.574524 26.8454 0.572378 26.7104C0.550593 25.2317 0.515508 23.7548 0.478532 22.2773C0.440611 20.7994 0.398582 19.3212 0.344199 17.8451C0.342714 17.8033 0.13628 16.1606 0.249397 16.0103C-2.59153 19.7734 -6.25549 22.7846 -10.6315 24.9488Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask15_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M-10.6315 24.9488C-11.1454 25.2033 -10.5519 30.6979 -10.5384 31.2208C-10.5259 31.6883 -9.93902 37.3033 -10.3099 37.4866C-5.93355 35.3214 -2.26896 32.3115 0.571015 28.5481C0.741798 28.3224 0.574524 26.8454 0.572378 26.7104C0.550593 25.2317 0.515508 23.7548 0.478532 22.2773C0.440611 20.7994 0.398582 19.3212 0.344199 17.8451C0.342714 17.8033 0.13628 16.1606 0.249397 16.0103C-2.59153 19.7734 -6.25549 22.7846 -10.6315 24.9488Z"
            fill="url(#paint13_linear_107_84227)"
          />
        </g>
        <mask
          id="mask16_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="31"
          y="7"
          width="3"
          height="3"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M31.5338 8.61424L32.2435 9.1209C32.503 8.30281 33.0968 7.92348 33.0968 7.92348L32.3858 7.41744C32.3858 7.41744 31.792 7.79677 31.5338 8.61424Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask16_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M31.5338 8.61424L32.2435 9.1209C32.503 8.30281 33.0968 7.92348 33.0968 7.92348L32.3858 7.41744C32.3858 7.41744 31.792 7.79677 31.5338 8.61424Z"
            fill="url(#paint14_linear_107_84227)"
          />
        </g>
        <mask
          id="mask17_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="24"
          y="10"
          width="3"
          height="3"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24.4534 11.2548C25.3247 11.5379 25.6617 12.095 25.6617 12.095L26.322 11.4889C26.322 11.4889 25.9846 10.9328 25.1127 10.6484L24.4534 11.2548Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask17_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24.4534 11.2548C25.3247 11.5379 25.6617 12.095 25.6617 12.095L26.322 11.4889C26.322 11.4889 25.9846 10.9328 25.1127 10.6484L24.4534 11.2548Z"
            fill="url(#paint15_linear_107_84227)"
          />
        </g>
        <mask
          id="mask18_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="17"
          y="18"
          width="2"
          height="3"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.9266 20.1996L18.3154 20.5324C18.2649 19.69 18.4368 19.1971 18.4368 19.1971L18.0479 18.8644C18.0479 18.8644 17.8761 19.3573 17.9266 20.1996Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask18_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.9266 20.1996L18.3154 20.5324C18.2649 19.69 18.4368 19.1971 18.4368 19.1971L18.0479 18.8644C18.0479 18.8644 17.8761 19.3573 17.9266 20.1996Z"
            fill="url(#paint16_linear_107_84227)"
          />
        </g>
        <mask
          id="mask19_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="15"
          y="30"
          width="2"
          height="2"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.0309 31.328L15.6313 31.8849C15.9712 31.1526 16.5695 30.8711 16.5695 30.8711L15.9691 30.3143C15.9691 30.3143 15.3705 30.5968 15.0309 31.328Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask19_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.0309 31.328L15.6313 31.8849C15.9712 31.1526 16.5695 30.8711 16.5695 30.8711L15.9691 30.3143C15.9691 30.3143 15.3705 30.5968 15.0309 31.328Z"
            fill="url(#paint17_linear_107_84227)"
          />
        </g>
        <mask
          id="mask20_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="110"
          y="-15"
          width="21"
          height="22"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M120.757 -14.3494C120.323 -14.2174 119.892 -14.074 119.463 -13.9245C118.638 -13.6376 117.823 -13.3218 117.011 -12.9984C115.84 -12.5312 114.679 -12.0426 113.506 -11.5814C112.588 -11.2195 111.445 -10.659 110.463 -11.0099C110.324 -11.06 110.451 -10.8775 110.473 -10.8416C110.61 -10.6059 110.78 -10.3857 110.949 -10.1699C111.166 -9.89203 111.394 -9.62003 111.634 -9.3596C111.74 -9.24376 111.932 -8.9778 112.098 -8.91956C112.923 -8.62396 113.769 -8.88696 114.573 -9.19179C115.653 -9.60048 116.719 -10.0444 117.789 -10.4798C118.858 -10.9158 119.93 -11.3438 121.017 -11.73C121.07 -11.75 121.123 -11.7675 121.175 -11.7866C120.868 -11.4399 120.535 -11.1114 120.207 -10.7854C118.956 -9.54386 117.772 -8.24788 116.665 -6.88598C116.397 -6.55625 116.135 -6.22236 115.877 -5.88621C115.663 -5.60654 115.386 -5.31707 115.317 -4.96829C115.287 -4.81806 115.351 -4.67133 115.423 -4.54697C115.693 -4.08607 116.052 -3.66192 116.402 -3.25906C116.637 -2.98888 116.884 -2.6721 117.203 -2.48522C117.35 -2.39837 117.562 -2.41337 117.729 -2.42658C119.334 -2.55623 120.92 -3.01384 122.463 -3.47245C123.431 -3.76106 124.394 -4.06381 125.37 -4.32775C125.627 -4.39756 125.887 -4.46372 126.146 -4.52666C125.771 -3.91144 125.265 -3.37793 124.774 -2.847C124.227 -2.257 123.691 -1.6526 123.328 -0.938749C123.183 -0.653442 123.123 -0.309332 123.234 -0.0140346C123.361 0.321581 123.635 0.628477 123.855 0.903221C124.075 1.17989 124.3 1.4529 124.539 1.71414C124.692 1.8788 124.86 2.08266 125.059 2.20306C125.336 2.37359 125.63 2.30318 125.935 2.21675C126.372 2.0945 126.803 1.94781 127.229 1.78691C127.758 1.58726 128.257 1.33896 128.756 1.08769C128.574 1.53917 128.368 1.98323 128.212 2.44037C127.948 3.2127 127.852 4.08053 128.199 4.82096C128.434 5.32154 128.844 5.76748 129.205 6.18357C129.384 6.3891 129.567 6.597 129.773 6.77884C129.787 6.79116 130.016 6.9842 129.942 6.82678C129.49 5.86199 129.847 4.79499 130.238 3.84139C130.456 3.31143 130.693 2.78583 130.83 2.2324C130.967 1.68209 130.874 1.22692 130.605 0.774698C130.599 0.735615 130.548 0.657791 130.452 0.541097C130.058 -0.0238975 129.614 -0.578601 129.113 -1.05586C128.912 -1.24644 128.701 -1.45338 128.411 -1.51095C127.863 -1.61933 127.296 -1.15669 126.825 -0.923263C126.754 -0.887438 126.683 -0.853797 126.612 -0.82022C126.896 -1.12648 127.18 -1.43353 127.442 -1.75915C127.889 -2.31797 128.26 -2.94009 128.417 -3.62758C128.486 -3.93169 128.517 -4.2752 128.406 -4.56626C128.275 -4.90745 128 -5.20731 127.781 -5.49317C127.437 -5.94353 127.052 -6.45918 126.579 -6.7965C126.321 -6.97949 126 -6.97159 125.689 -6.92519C125.28 -6.86421 124.872 -6.76463 124.468 -6.66884C123.677 -6.48098 122.895 -6.25328 122.115 -6.02037C120.958 -5.6743 119.803 -5.31168 118.63 -5.02291C119.053 -5.538 119.49 -6.04348 119.935 -6.5417C120.526 -7.20216 121.14 -7.84542 121.769 -8.4729C122.297 -8.99971 122.831 -9.51899 123.293 -10.1014C123.731 -10.6549 124.12 -11.3101 124.232 -11.9978C124.261 -12.1699 124.202 -12.3267 124.118 -12.471C123.847 -12.9332 123.487 -13.3575 123.136 -13.7618C122.788 -14.1618 122.454 -14.6376 121.858 -14.6229C121.809 -14.6218 121.759 -14.6179 121.709 -14.6117C121.388 -14.5722 121.059 -14.441 120.757 -14.3494Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask20_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M120.757 -14.3494C120.323 -14.2174 119.892 -14.074 119.463 -13.9245C118.638 -13.6376 117.823 -13.3218 117.011 -12.9984C115.84 -12.5312 114.679 -12.0426 113.506 -11.5814C112.588 -11.2195 111.445 -10.659 110.463 -11.0099C110.324 -11.06 110.451 -10.8775 110.473 -10.8416C110.61 -10.6059 110.78 -10.3857 110.949 -10.1699C111.166 -9.89203 111.394 -9.62003 111.634 -9.3596C111.74 -9.24376 111.932 -8.9778 112.098 -8.91956C112.923 -8.62396 113.769 -8.88696 114.573 -9.19179C115.653 -9.60048 116.719 -10.0444 117.789 -10.4798C118.858 -10.9158 119.93 -11.3438 121.017 -11.73C121.07 -11.75 121.123 -11.7675 121.175 -11.7866C120.868 -11.4399 120.535 -11.1114 120.207 -10.7854C118.956 -9.54386 117.772 -8.24788 116.665 -6.88598C116.397 -6.55625 116.135 -6.22236 115.877 -5.88621C115.663 -5.60654 115.386 -5.31707 115.317 -4.96829C115.287 -4.81806 115.351 -4.67133 115.423 -4.54697C115.693 -4.08607 116.052 -3.66192 116.402 -3.25906C116.637 -2.98888 116.884 -2.6721 117.203 -2.48522C117.35 -2.39837 117.562 -2.41337 117.729 -2.42658C119.334 -2.55623 120.92 -3.01384 122.463 -3.47245C123.431 -3.76106 124.394 -4.06381 125.37 -4.32775C125.627 -4.39756 125.887 -4.46372 126.146 -4.52666C125.771 -3.91144 125.265 -3.37793 124.774 -2.847C124.227 -2.257 123.691 -1.6526 123.328 -0.938749C123.183 -0.653442 123.123 -0.309332 123.234 -0.0140346C123.361 0.321581 123.635 0.628477 123.855 0.903221C124.075 1.17989 124.3 1.4529 124.539 1.71414C124.692 1.8788 124.86 2.08266 125.059 2.20306C125.336 2.37359 125.63 2.30318 125.935 2.21675C126.372 2.0945 126.803 1.94781 127.229 1.78691C127.758 1.58726 128.257 1.33896 128.756 1.08769C128.574 1.53917 128.368 1.98323 128.212 2.44037C127.948 3.2127 127.852 4.08053 128.199 4.82096C128.434 5.32154 128.844 5.76748 129.205 6.18357C129.384 6.3891 129.567 6.597 129.773 6.77884C129.787 6.79116 130.016 6.9842 129.942 6.82678C129.49 5.86199 129.847 4.79499 130.238 3.84139C130.456 3.31143 130.693 2.78583 130.83 2.2324C130.967 1.68209 130.874 1.22692 130.605 0.774698C130.599 0.735615 130.548 0.657791 130.452 0.541097C130.058 -0.0238975 129.614 -0.578601 129.113 -1.05586C128.912 -1.24644 128.701 -1.45338 128.411 -1.51095C127.863 -1.61933 127.296 -1.15669 126.825 -0.923263C126.754 -0.887438 126.683 -0.853797 126.612 -0.82022C126.896 -1.12648 127.18 -1.43353 127.442 -1.75915C127.889 -2.31797 128.26 -2.94009 128.417 -3.62758C128.486 -3.93169 128.517 -4.2752 128.406 -4.56626C128.275 -4.90745 128 -5.20731 127.781 -5.49317C127.437 -5.94353 127.052 -6.45918 126.579 -6.7965C126.321 -6.97949 126 -6.97159 125.689 -6.92519C125.28 -6.86421 124.872 -6.76463 124.468 -6.66884C123.677 -6.48098 122.895 -6.25328 122.115 -6.02037C120.958 -5.6743 119.803 -5.31168 118.63 -5.02291C119.053 -5.538 119.49 -6.04348 119.935 -6.5417C120.526 -7.20216 121.14 -7.84542 121.769 -8.4729C122.297 -8.99971 122.831 -9.51899 123.293 -10.1014C123.731 -10.6549 124.12 -11.3101 124.232 -11.9978C124.261 -12.1699 124.202 -12.3267 124.118 -12.471C123.847 -12.9332 123.487 -13.3575 123.136 -13.7618C122.788 -14.1618 122.454 -14.6376 121.858 -14.6229C121.809 -14.6218 121.759 -14.6179 121.709 -14.6117C121.388 -14.5722 121.059 -14.441 120.757 -14.3494Z"
            fill="url(#paint18_linear_107_84227)"
          />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M129.689 6.8367C129.688 6.83634 129.687 6.83507 129.686 6.83475C129.685 6.83315 129.685 6.83442 129.689 6.8367Z"
          stroke="black"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M132.624 6.49664C132.623 6.49537 132.622 6.49504 132.621 6.49371C132.62 6.49312 132.621 6.49345 132.624 6.49664Z"
          fill="black"
        />
        <mask
          id="mask21_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="128"
          y="-2"
          width="3"
          height="9"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M129.044 0.773752C128.901 1.24044 128.737 1.69791 128.615 2.17013C128.41 2.96887 128.349 3.87114 128.662 4.65142C128.873 5.17888 129.232 5.65372 129.548 6.09578C129.706 6.31383 129.866 6.53508 130.045 6.7299C130.057 6.74271 130.256 6.94976 130.19 6.78425C129.783 5.76731 130.06 4.66439 130.37 3.67946C130.542 3.1327 130.73 2.59046 130.833 2.01687C130.937 1.4464 130.846 0.970106 130.607 0.49218C130.601 0.451923 130.556 0.369761 130.472 0.24452C130.123 -0.353387 129.733 -0.941528 129.296 -1.45161C129.276 -1.47552 129.255 -1.50071 129.234 -1.52483C129.623 -0.465434 129.044 0.773752 129.044 0.773752Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask21_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M129.044 0.773752C128.901 1.24044 128.737 1.69791 128.615 2.17013C128.41 2.96887 128.349 3.87114 128.662 4.65142C128.873 5.17888 129.232 5.65372 129.548 6.09578C129.706 6.31383 129.866 6.53508 130.045 6.7299C130.057 6.74271 130.256 6.94976 130.19 6.78425C129.783 5.76731 130.06 4.66439 130.37 3.67946C130.542 3.1327 130.73 2.59046 130.833 2.01687C130.937 1.4464 130.846 0.970106 130.607 0.49218C130.601 0.451923 130.556 0.369761 130.472 0.24452C130.123 -0.353387 129.733 -0.941528 129.296 -1.45161C129.276 -1.47552 129.255 -1.50071 129.234 -1.52483C129.623 -0.465434 129.044 0.773752 129.044 0.773752Z"
            fill="url(#paint19_linear_107_84227)"
          />
        </g>
        <mask
          id="mask22_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="122"
          y="-5"
          width="7"
          height="8"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M125.207 -3.83306C125.469 -3.90255 125.733 -3.96927 125.996 -4.03188C125.613 -3.42787 125.097 -2.90205 124.596 -2.37968C124.038 -1.79865 123.492 -1.20419 123.121 -0.502752C122.972 -0.221877 122.91 0.11516 123.021 0.405177C123.148 0.733555 123.425 1.03201 123.648 1.30202C123.87 1.57201 124.097 1.83844 124.339 2.09312C124.456 2.21613 124.583 2.36143 124.726 2.47517C124.609 1.50935 126.258 -0.195767 126.258 -0.195767L126.547 -0.444171C126.516 -0.429552 126.484 -0.414086 126.453 -0.400446C126.742 -0.702606 127.033 -1.0046 127.299 -1.32426C127.755 -1.87363 128.134 -2.48552 128.296 -3.16055C128.368 -3.45864 128.401 -3.79517 128.289 -4.08001C128.289 -4.08001 128.155 -4.37262 127.028 -4.23403C126.589 -4.18011 125.999 -4.06158 125.207 -3.83306Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask22_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M125.207 -3.83306C125.469 -3.90255 125.733 -3.96927 125.996 -4.03188C125.613 -3.42787 125.097 -2.90205 124.596 -2.37968C124.038 -1.79865 123.492 -1.20419 123.121 -0.502752C122.972 -0.221877 122.91 0.11516 123.021 0.405177C123.148 0.733555 123.425 1.03201 123.648 1.30202C123.87 1.57201 124.097 1.83844 124.339 2.09312C124.456 2.21613 124.583 2.36143 124.726 2.47517C124.609 1.50935 126.258 -0.195767 126.258 -0.195767L126.547 -0.444171C126.516 -0.429552 126.484 -0.414086 126.453 -0.400446C126.742 -0.702606 127.033 -1.0046 127.299 -1.32426C127.755 -1.87363 128.134 -2.48552 128.296 -3.16055C128.368 -3.45864 128.401 -3.79517 128.289 -4.08001C128.289 -4.08001 128.155 -4.37262 127.028 -4.23403C126.589 -4.18011 125.999 -4.06158 125.207 -3.83306Z"
            fill="url(#paint20_linear_107_84227)"
          />
        </g>
        <mask
          id="mask23_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="287"
          y="0"
          width="9"
          height="7"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M287.723 4.19007C287.723 4.19007 290.003 6.24537 293.911 6.48694L295.464 3.07227C291.554 2.83038 289.275 0.775404 289.275 0.775404L287.723 4.19007Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask23_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M287.723 4.19007C287.723 4.19007 290.003 6.24537 293.911 6.48694L295.464 3.07227C291.554 2.83038 289.275 0.775404 289.275 0.775404L287.723 4.19007Z"
            fill="url(#paint21_linear_107_84227)"
          />
        </g>
        <mask
          id="mask24_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="337"
          y="-4"
          width="7"
          height="8"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M337.007 -0.853538C337.007 -0.853538 338.147 2.02129 341.141 3.75758L343.44 1.03241C340.446 -0.70388 339.305 -3.57903 339.305 -3.57903L337.007 -0.853538Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask24_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M337.007 -0.853538C337.007 -0.853538 338.147 2.02129 341.141 3.75758L343.44 1.03241C340.446 -0.70388 339.305 -3.57903 339.305 -3.57903L337.007 -0.853538Z"
            fill="url(#paint22_linear_107_84227)"
          />
        </g>
        <mask
          id="mask25_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="272"
          y="0"
          width="5"
          height="4"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M272.839 2.53152L273.909 3.99142C273.909 3.99142 275.201 3.57439 276.088 2.05536L275.017 0.595144C274.13 2.11322 272.839 2.53152 272.839 2.53152Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask25_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M272.839 2.53152L273.909 3.99142C273.909 3.99142 275.201 3.57439 276.088 2.05536L275.017 0.595144C274.13 2.11322 272.839 2.53152 272.839 2.53152Z"
            fill="url(#paint23_linear_107_84227)"
          />
        </g>
        <mask
          id="mask26_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="263"
          y="33"
          width="7"
          height="4"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M263.417 33.8517L263.857 36.7076C263.857 36.7076 266.362 37.2213 269.194 35.9162L268.754 33.0603C265.922 34.3654 263.417 33.8517 263.417 33.8517Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask26_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M263.417 33.8517L263.857 36.7076C263.857 36.7076 266.362 37.2213 269.194 35.9162L268.754 33.0603C265.922 34.3654 263.417 33.8517 263.417 33.8517Z"
            fill="url(#paint24_linear_107_84227)"
          />
        </g>
        <mask
          id="mask27_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="250"
          y="26"
          width="3"
          height="3"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M250.404 26.7185L250.741 28.1089C250.741 28.1089 251.833 28.2778 252.97 27.5407L252.633 26.1513C251.497 26.8874 250.404 26.7185 250.404 26.7185Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask27_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M250.404 26.7185L250.741 28.1089C250.741 28.1089 251.833 28.2778 252.97 27.5407L252.633 26.1513C251.497 26.8874 250.404 26.7185 250.404 26.7185Z"
            fill="url(#paint25_linear_107_84227)"
          />
        </g>
        <mask
          id="mask28_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="357"
          y="7"
          width="6"
          height="6"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M357.331 10.8379L359.083 12.6711C359.083 12.6711 361.078 11.964 362.379 9.82959L360.628 7.9955C359.326 10.13 357.331 10.8379 357.331 10.8379Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask28_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M357.331 10.8379L359.083 12.6711C359.083 12.6711 361.078 11.964 362.379 9.82959L360.628 7.9955C359.326 10.13 357.331 10.8379 357.331 10.8379Z"
            fill="url(#paint26_linear_107_84227)"
          />
        </g>
        <mask
          id="mask29_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="405"
          y="14"
          width="8"
          height="10"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M405.944 15.3562C405.944 15.3562 408.645 21.7953 411.353 23.2596L412.423 21.9071C409.714 20.4437 407.014 14.0037 407.014 14.0037L405.944 15.3562Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask29_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M405.944 15.3562C405.944 15.3562 408.645 21.7953 411.353 23.2596L412.423 21.9071C409.714 20.4437 407.014 14.0037 407.014 14.0037L405.944 15.3562Z"
            fill="url(#paint27_linear_107_84227)"
          />
        </g>
        <mask
          id="mask30_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="395"
          y="-3"
          width="7"
          height="6"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M395.936 0.511986C395.936 0.511986 397.748 2.19583 400.644 2.26645L401.564 -0.714559C398.669 -0.78707 396.856 -2.46997 396.856 -2.46997L395.936 0.511986Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask30_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M395.936 0.511986C395.936 0.511986 397.748 2.19583 400.644 2.26645L401.564 -0.714559C398.669 -0.78707 396.856 -2.46997 396.856 -2.46997L395.936 0.511986Z"
            fill="url(#paint28_linear_107_84227)"
          />
        </g>
        <mask
          id="mask31_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="374"
          y="11"
          width="5"
          height="7"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M374.312 13.101C374.312 13.101 374.661 15.3479 376.414 17.2026L378.344 15.8007C376.591 13.9461 376.243 11.6982 376.243 11.6982L374.312 13.101Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask31_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M374.312 13.101C374.312 13.101 374.661 15.3479 376.414 17.2026L378.344 15.8007C376.591 13.9461 376.243 11.6982 376.243 11.6982L374.312 13.101Z"
            fill="url(#paint29_linear_107_84227)"
          />
        </g>
        <mask
          id="mask32_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="343"
          y="38"
          width="7"
          height="6"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M343.694 41.0756L345.26 43.4616C345.26 43.4616 347.456 42.9886 349.134 40.769L347.568 38.3821C345.89 40.6017 343.694 41.0756 343.694 41.0756Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask32_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M343.694 41.0756L345.26 43.4616C345.26 43.4616 347.456 42.9886 349.134 40.769L347.568 38.3821C345.89 40.6017 343.694 41.0756 343.694 41.0756Z"
            fill="url(#paint30_linear_107_84227)"
          />
        </g>
        <mask
          id="mask33_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="331"
          y="31"
          width="7"
          height="7"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M331.997 35.8361L334.683 37.4147C334.683 37.4147 336.603 35.7996 337.171 32.701L334.485 31.1201C333.916 34.2188 331.997 35.8361 331.997 35.8361Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask33_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M331.997 35.8361L334.683 37.4147C334.683 37.4147 336.603 35.7996 337.171 32.701L334.485 31.1201C333.916 34.2188 331.997 35.8361 331.997 35.8361Z"
            fill="url(#paint31_linear_107_84227)"
          />
        </g>
        <mask
          id="mask34_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="320"
          y="-4"
          width="12"
          height="22"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M320.368 4.94878C319.855 5.20335 320.448 10.6979 320.462 11.2208C320.474 11.6883 321.061 17.3033 320.69 17.4866C325.066 15.3214 328.731 12.3115 331.571 8.54806C331.742 8.32236 331.575 6.84544 331.572 6.71038C331.551 5.23173 331.516 3.75484 331.479 2.27731C331.441 0.799445 331.399 -0.678773 331.344 -2.1549C331.343 -2.19666 331.136 -3.83936 331.249 -3.98973C328.408 -0.226625 324.745 2.78456 320.368 4.94878Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask34_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M320.368 4.94878C319.855 5.20335 320.448 10.6979 320.462 11.2208C320.474 11.6883 321.061 17.3033 320.69 17.4866C325.066 15.3214 328.731 12.3115 331.571 8.54806C331.742 8.32236 331.575 6.84544 331.572 6.71038C331.551 5.23173 331.516 3.75484 331.479 2.27731C331.441 0.799445 331.399 -0.678773 331.344 -2.1549C331.343 -2.19666 331.136 -3.83936 331.249 -3.98973C328.408 -0.226625 324.745 2.78456 320.368 4.94878Z"
            fill="url(#paint32_linear_107_84227)"
          />
        </g>
        <mask
          id="mask35_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="348"
          y="-2"
          width="2"
          height="3"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M348.927 0.199625L349.315 0.532353C349.265 -0.309984 349.437 -0.802894 349.437 -0.802894L349.048 -1.13562C349.048 -1.13562 348.876 -0.642712 348.927 0.199625Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask35_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M348.927 0.199625L349.315 0.532353C349.265 -0.309984 349.437 -0.802894 349.437 -0.802894L349.048 -1.13562C349.048 -1.13562 348.876 -0.642712 348.927 0.199625Z"
            fill="url(#paint33_linear_107_84227)"
          />
        </g>
        <mask
          id="mask36_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="346"
          y="10"
          width="2"
          height="2"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M346.031 11.328L346.631 11.8849C346.971 11.1526 347.569 10.8711 347.569 10.8711L346.969 10.3143C346.969 10.3143 346.37 10.5968 346.031 11.328Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask36_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M346.031 11.328L346.631 11.8849C346.971 11.1526 347.569 10.8711 347.569 10.8711L346.969 10.3143C346.969 10.3143 346.37 10.5968 346.031 11.328Z"
            fill="url(#paint34_linear_107_84227)"
          />
        </g>
        <mask
          id="mask37_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="277"
          y="1"
          width="34"
          height="53"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M308.969 2.7058C308.563 2.92443 308.16 3.1529 307.775 3.40747C307.748 3.42554 307.306 3.67734 307.33 3.78921C307.725 5.6406 306.754 7.44184 305.377 8.61321C305.348 8.63728 305.319 8.66103 305.29 8.68477C305.133 8.74395 304.975 8.79963 304.818 8.85437C303.807 9.20839 302.646 9.83038 301.631 10.1758C300.143 10.682 298.845 11.0187 297.476 11.7932C296.365 12.4227 295.277 13.1216 294.374 14.0396C292.992 15.4453 292.345 17.3588 293.044 19.2676C293.413 20.2778 294.061 21.1807 294.658 22.0623C295.341 23.0693 296.061 24.0501 296.808 25.0078C297.824 26.3094 299.345 28.1159 298.324 29.8436C298.319 29.8514 298.314 29.8583 298.308 29.8668C297.293 30.064 296.246 30.133 295.217 30.226C293.019 30.4253 290.81 30.5965 288.674 31.1819C287.274 31.566 285.96 32.1573 284.681 32.8455C283.439 33.5135 282.125 34.2551 281.241 35.3934C279.894 37.1293 279.841 39.529 280.071 41.6248C280.311 43.826 280.842 46.0216 280.487 48.2419C280.159 50.2971 279.045 52.2772 277.438 53.581C277.371 53.6341 277.305 53.6856 277.238 53.7356C277.253 53.7246 277.16 53.7901 277.098 53.8534C277.036 53.9135 277.005 53.9714 277.128 53.9502C277.415 53.8989 277.71 53.7393 277.969 53.6179C278.763 53.243 279.593 52.8297 280.295 52.2942C281.992 50.9992 283.222 49.2154 283.772 47.132C284.345 44.9717 283.911 42.7376 283.614 40.57C283.321 38.4331 283.178 36.0403 284.317 34.1161C284.529 33.7567 284.794 33.4355 285.089 33.1437C285.865 32.9008 286.663 32.737 287.461 32.6003C289.643 32.2272 291.861 32.1438 294.055 31.8798C295.116 31.7521 296.121 31.5093 297.113 31.1051C298.08 30.7105 299.003 30.1928 299.9 29.6586C300.453 29.3289 301.012 28.9565 301.445 28.4699C302.804 26.9486 301.728 25.0623 300.698 23.7243C299.317 21.9277 297.83 20.1202 296.787 18.0933C296.327 17.1953 296.083 16.2199 296.215 15.2108C296.338 14.2569 296.821 13.4047 297.425 12.6811C297.697 12.3558 298.004 12.0574 298.333 11.79C298.533 11.7161 298.747 11.6416 298.991 11.5577C299.519 11.3776 300.053 11.2156 300.584 11.0494C303.284 10.2067 306.004 9.07131 308.257 7.31719C309.701 6.19201 310.944 4.51869 310.865 2.58978C310.856 2.3699 310.819 2.15196 310.773 1.93614C310.771 1.92506 310.754 1.92142 310.728 1.92495C310.455 1.95894 309.048 2.66325 308.969 2.7058Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask37_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M308.969 2.7058C308.563 2.92443 308.16 3.1529 307.775 3.40747C307.748 3.42554 307.306 3.67734 307.33 3.78921C307.725 5.6406 306.754 7.44184 305.377 8.61321C305.348 8.63728 305.319 8.66103 305.29 8.68477C305.133 8.74395 304.975 8.79963 304.818 8.85437C303.807 9.20839 302.646 9.83038 301.631 10.1758C300.143 10.682 298.845 11.0187 297.476 11.7932C296.365 12.4227 295.277 13.1216 294.374 14.0396C292.992 15.4453 292.345 17.3588 293.044 19.2676C293.413 20.2778 294.061 21.1807 294.658 22.0623C295.341 23.0693 296.061 24.0501 296.808 25.0078C297.824 26.3094 299.345 28.1159 298.324 29.8436C298.319 29.8514 298.314 29.8583 298.308 29.8668C297.293 30.064 296.246 30.133 295.217 30.226C293.019 30.4253 290.81 30.5965 288.674 31.1819C287.274 31.566 285.96 32.1573 284.681 32.8455C283.439 33.5135 282.125 34.2551 281.241 35.3934C279.894 37.1293 279.841 39.529 280.071 41.6248C280.311 43.826 280.842 46.0216 280.487 48.2419C280.159 50.2971 279.045 52.2772 277.438 53.581C277.371 53.6341 277.305 53.6856 277.238 53.7356C277.253 53.7246 277.16 53.7901 277.098 53.8534C277.036 53.9135 277.005 53.9714 277.128 53.9502C277.415 53.8989 277.71 53.7393 277.969 53.6179C278.763 53.243 279.593 52.8297 280.295 52.2942C281.992 50.9992 283.222 49.2154 283.772 47.132C284.345 44.9717 283.911 42.7376 283.614 40.57C283.321 38.4331 283.178 36.0403 284.317 34.1161C284.529 33.7567 284.794 33.4355 285.089 33.1437C285.865 32.9008 286.663 32.737 287.461 32.6003C289.643 32.2272 291.861 32.1438 294.055 31.8798C295.116 31.7521 296.121 31.5093 297.113 31.1051C298.08 30.7105 299.003 30.1928 299.9 29.6586C300.453 29.3289 301.012 28.9565 301.445 28.4699C302.804 26.9486 301.728 25.0623 300.698 23.7243C299.317 21.9277 297.83 20.1202 296.787 18.0933C296.327 17.1953 296.083 16.2199 296.215 15.2108C296.338 14.2569 296.821 13.4047 297.425 12.6811C297.697 12.3558 298.004 12.0574 298.333 11.79C298.533 11.7161 298.747 11.6416 298.991 11.5577C299.519 11.3776 300.053 11.2156 300.584 11.0494C303.284 10.2067 306.004 9.07131 308.257 7.31719C309.701 6.19201 310.944 4.51869 310.865 2.58978C310.856 2.3699 310.819 2.15196 310.773 1.93614C310.771 1.92506 310.754 1.92142 310.728 1.92495C310.455 1.95894 309.048 2.66325 308.969 2.7058Z"
            fill="url(#paint35_linear_107_84227)"
          />
        </g>
        <mask
          id="mask38_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="305"
          y="1"
          width="6"
          height="8"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M309.07 1.92438C308.7 2.13103 308.333 2.34847 307.982 2.59041C307.958 2.60724 307.554 2.84709 307.577 2.9542C307.937 4.67084 307.132 6.33551 305.948 7.45315C305.801 7.67749 305.658 7.90536 305.497 8.1185C305.441 8.19321 305.382 8.26505 305.321 8.33403C306.427 7.78075 307.483 7.12927 308.445 6.34656C309.759 5.27418 310.888 3.67564 310.806 1.82386C310.796 1.61219 310.761 1.40217 310.718 1.19493C310.715 1.18446 310.7 1.18147 310.676 1.18471C310.426 1.21514 309.143 1.88367 309.07 1.92438Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask38_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M309.07 1.92438C308.7 2.13103 308.333 2.34847 307.982 2.59041C307.958 2.60724 307.554 2.84709 307.577 2.9542C307.937 4.67084 307.132 6.33551 305.948 7.45315C305.801 7.67749 305.658 7.90536 305.497 8.1185C305.441 8.19321 305.382 8.26505 305.321 8.33403C306.427 7.78075 307.483 7.12927 308.445 6.34656C309.759 5.27418 310.888 3.67564 310.806 1.82386C310.796 1.61219 310.761 1.40217 310.718 1.19493C310.715 1.18446 310.7 1.18147 310.676 1.18471C310.426 1.21514 309.143 1.88367 309.07 1.92438Z"
            fill="url(#paint36_linear_107_84227)"
          />
        </g>
        <mask
          id="mask39_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="276"
          y="31"
          width="10"
          height="23"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M284.516 32.6187C283.288 33.2726 281.991 33.9979 281.117 35.11C279.785 36.8065 279.73 39.1484 279.953 41.1935C280.188 43.3409 280.709 45.4842 280.356 47.6514C280.029 49.6572 278.926 51.5916 277.339 52.8662C277.273 52.9177 277.208 52.9683 277.142 53.0173C277.156 53.0064 277.065 53.0713 277.004 53.1317C276.943 53.1921 276.911 53.2478 277.033 53.2262C277.316 53.1768 277.607 53.02 277.863 52.9008C278.648 52.5344 279.466 52.1307 280.161 51.6063C281.837 50.3401 283.053 48.5979 283.6 46.5632C284.167 44.4551 283.742 42.2748 283.452 40.1591C283.165 38.0732 283.028 35.7392 284.153 33.8592C284.364 33.5087 284.626 33.1941 284.917 32.9091C284.943 32.9012 284.97 32.8935 284.996 32.8856C285.259 32.534 285.546 32.2247 285.853 31.9529C285.402 32.1603 284.956 32.3833 284.516 32.6187Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask39_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M284.516 32.6187C283.288 33.2726 281.991 33.9979 281.117 35.11C279.785 36.8065 279.73 39.1484 279.953 41.1935C280.188 43.3409 280.709 45.4842 280.356 47.6514C280.029 49.6572 278.926 51.5916 277.339 52.8662C277.273 52.9177 277.208 52.9683 277.142 53.0173C277.156 53.0064 277.065 53.0713 277.004 53.1317C276.943 53.1921 276.911 53.2478 277.033 53.2262C277.316 53.1768 277.607 53.02 277.863 52.9008C278.648 52.5344 279.466 52.1307 280.161 51.6063C281.837 50.3401 283.053 48.5979 283.6 46.5632C284.167 44.4551 283.742 42.2748 283.452 40.1591C283.165 38.0732 283.028 35.7392 284.153 33.8592C284.364 33.5087 284.626 33.1941 284.917 32.9091C284.943 32.9012 284.97 32.8935 284.996 32.8856C285.259 32.534 285.546 32.2247 285.853 31.9529C285.402 32.1603 284.956 32.3833 284.516 32.6187Z"
            fill="url(#paint37_linear_107_84227)"
          />
        </g>
        <mask
          id="mask40_107_84227"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="292"
          y="11"
          width="11"
          height="19"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M296.706 11.3757C295.807 11.9092 294.946 12.5054 294.205 13.2403C292.769 14.6641 292.092 16.5982 292.81 18.5227C293.19 19.5409 293.857 20.4498 294.472 21.3385C295.177 22.353 295.919 23.3406 296.69 24.3052C297.682 25.5423 299.135 27.2346 298.396 28.8924C298.607 29.0953 298.761 29.3649 298.701 29.649C299.1 29.4372 299.492 29.2147 299.878 28.9901C300.452 28.6549 301.032 28.277 301.483 27.785C302.896 26.2442 301.787 24.3434 300.724 22.9962C299.3 21.1878 297.766 19.3672 296.692 17.3245C296.218 16.4197 295.969 15.436 296.108 14.4168C296.24 13.4542 296.742 12.5917 297.37 11.8595C297.602 11.5882 297.86 11.3375 298.133 11.1068C297.986 11.1079 297.839 11.1178 297.695 11.1347C297.358 11.1763 297.029 11.2606 296.706 11.3757Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask40_107_84227)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M296.706 11.3757C295.807 11.9092 294.946 12.5054 294.205 13.2403C292.769 14.6641 292.092 16.5982 292.81 18.5227C293.19 19.5409 293.857 20.4498 294.472 21.3385C295.177 22.353 295.919 23.3406 296.69 24.3052C297.682 25.5423 299.135 27.2346 298.396 28.8924C298.607 29.0953 298.761 29.3649 298.701 29.649C299.1 29.4372 299.492 29.2147 299.878 28.9901C300.452 28.6549 301.032 28.277 301.483 27.785C302.896 26.2442 301.787 24.3434 300.724 22.9962C299.3 21.1878 297.766 19.3672 296.692 17.3245C296.218 16.4197 295.969 15.436 296.108 14.4168C296.24 13.4542 296.742 12.5917 297.37 11.8595C297.602 11.5882 297.86 11.3375 298.133 11.1068C297.986 11.1079 297.839 11.1178 297.695 11.1347C297.358 11.1763 297.029 11.2606 296.706 11.3757Z"
            fill="url(#paint38_linear_107_84227)"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_107_84227"
          x1="6.13116"
          y1="21.2499"
          x2="12.1946"
          y2="20.2293"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FBE421" />
          <stop offset="1" stop-color="#C8D82A" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_107_84227"
          x1="19.058"
          y1="-1.47389"
          x2="23.3322"
          y2="-2.65531"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F7B549" />
          <stop offset="1" stop-color="#F7A528" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_107_84227"
          x1="91.5366"
          y1="17.5641"
          x2="100.374"
          y2="10.9124"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#6DCFE6" />
          <stop offset="1" stop-color="#01A7DB" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_107_84227"
          x1="118.076"
          y1="34.7527"
          x2="123.045"
          y2="32.5705"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F61772" />
          <stop offset="1" stop-color="#F7A528" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_107_84227"
          x1="26.4505"
          y1="30.1101"
          x2="31.5631"
          y2="29.8704"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B3DF85" />
          <stop offset="1" stop-color="#83C642" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_107_84227"
          x1="75.3998"
          y1="41.2179"
          x2="80.8659"
          y2="39.9858"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E41A52" />
          <stop offset="1" stop-color="#FFB3B3" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_107_84227"
          x1="81.7329"
          y1="-7.62242"
          x2="87.3645"
          y2="-6.04446"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F61772" />
          <stop offset="1" stop-color="#F7A528" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_107_84227"
          x1="54.6721"
          y1="5.62717"
          x2="59.4939"
          y2="4.45203"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BD1D67" />
          <stop offset="1" stop-color="#B5178C" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_107_84227"
          x1="64.1185"
          y1="20.5144"
          x2="69.0204"
          y2="18.1665"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F44274" />
          <stop offset="1" stop-color="#E41F9A" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_107_84227"
          x1="43.7367"
          y1="35.4442"
          x2="47.3951"
          y2="35.2507"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B5178C" />
          <stop offset="1" stop-color="#4D69AE" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_107_84227"
          x1="12.8578"
          y1="60.7201"
          x2="18.2744"
          y2="60.444"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F44274" />
          <stop offset="1" stop-color="#E41F9A" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_107_84227"
          x1="1.65052"
          y1="53.9783"
          x2="6.98331"
          y2="54.5822"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#6DCFE6" />
          <stop offset="1" stop-color="#01A7DB" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_107_84227"
          x1="39.7562"
          y1="7.82594"
          x2="38.7735"
          y2="15.5392"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#6DCFE6" />
          <stop offset="1" stop-color="#01A7DB" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_107_84227"
          x1="-2.85689"
          y1="28.6171"
          x2="-16.9199"
          y2="25.446"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F7B549" />
          <stop offset="1" stop-color="#F7A528" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_107_84227"
          x1="32.8039"
          y1="7.90003"
          x2="31.2526"
          y2="8.36985"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#6DCFE6" />
          <stop offset="1" stop-color="#01A7DB" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_107_84227"
          x1="26.3402"
          y1="11.0795"
          x2="25.6359"
          y2="12.1108"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BD1D67" />
          <stop offset="1" stop-color="#B5178C" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_107_84227"
          x1="18.2054"
          y1="18.9076"
          x2="17.4649"
          y2="18.8873"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B5178C" />
          <stop offset="1" stop-color="#4D69AE" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_107_84227"
          x1="16.3087"
          y1="30.7413"
          x2="14.9381"
          y2="31.3621"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FBE421" />
          <stop offset="1" stop-color="#C8D82A" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_107_84227"
          x1="111.984"
          y1="-14.6992"
          x2="99.0202"
          y2="-2.43654"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00557255" stop-color="#E9195C" />
          <stop offset="0.998279" stop-color="#F76690" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_107_84227"
          x1="128.829"
          y1="-0.212981"
          x2="124.195"
          y2="1.01115"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00557255" stop-color="#E9195C" />
          <stop offset="0.998279" stop-color="#F76690" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_107_84227"
          x1="124.382"
          y1="-4.06845"
          x2="119.537"
          y2="-2.45078"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00557255" stop-color="#E9195C" />
          <stop offset="0.998279" stop-color="#F76690" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_107_84227"
          x1="286.192"
          y1="4.24002"
          x2="292.123"
          y2="0.434281"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B3DF85" />
          <stop offset="1" stop-color="#83C642" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_107_84227"
          x1="337.131"
          y1="1.24989"
          x2="343.195"
          y2="0.229289"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FBE421" />
          <stop offset="1" stop-color="#C8D82A" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_107_84227"
          x1="273.063"
          y1="2.19978"
          x2="276.314"
          y2="2.25572"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BD1D67" />
          <stop offset="1" stop-color="#B5178C" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_107_84227"
          x1="263.085"
          y1="34.6498"
          x2="268.258"
          y2="33.0862"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FBE421" />
          <stop offset="1" stop-color="#C8D82A" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_107_84227"
          x1="250.36"
          y1="27.0616"
          x2="252.755"
          y2="26.5881"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#6DCFE6" />
          <stop offset="1" stop-color="#01A7DB" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_107_84227"
          x1="357.45"
          y1="10.1101"
          x2="362.563"
          y2="9.87035"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B3DF85" />
          <stop offset="1" stop-color="#83C642" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_107_84227"
          x1="406.4"
          y1="21.2179"
          x2="411.866"
          y2="19.9858"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E41A52" />
          <stop offset="1" stop-color="#FFB3B3" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_107_84227"
          x1="395.119"
          y1="0.514376"
          x2="400.02"
          y2="-1.83352"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F44274" />
          <stop offset="1" stop-color="#E41F9A" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_107_84227"
          x1="374.737"
          y1="15.4442"
          x2="378.395"
          y2="15.2507"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B5178C" />
          <stop offset="1" stop-color="#4D69AE" />
        </linearGradient>
        <linearGradient
          id="paint30_linear_107_84227"
          x1="343.858"
          y1="40.7201"
          x2="349.274"
          y2="40.444"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F44274" />
          <stop offset="1" stop-color="#E41F9A" />
        </linearGradient>
        <linearGradient
          id="paint31_linear_107_84227"
          x1="332.651"
          y1="33.9783"
          x2="337.983"
          y2="34.5822"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#6DCFE6" />
          <stop offset="1" stop-color="#01A7DB" />
        </linearGradient>
        <linearGradient
          id="paint32_linear_107_84227"
          x1="328.143"
          y1="8.61715"
          x2="314.08"
          y2="5.44599"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F7B549" />
          <stop offset="1" stop-color="#F7A528" />
        </linearGradient>
        <linearGradient
          id="paint33_linear_107_84227"
          x1="349.205"
          y1="-1.09242"
          x2="348.465"
          y2="-1.11272"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B5178C" />
          <stop offset="1" stop-color="#4D69AE" />
        </linearGradient>
        <linearGradient
          id="paint34_linear_107_84227"
          x1="347.309"
          y1="10.7413"
          x2="345.938"
          y2="11.3621"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FBE421" />
          <stop offset="1" stop-color="#C8D82A" />
        </linearGradient>
        <linearGradient
          id="paint35_linear_107_84227"
          x1="291.764"
          y1="7.25301"
          x2="307.5"
          y2="12.5301"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F61772" />
          <stop offset="1" stop-color="#C6211A" />
        </linearGradient>
        <linearGradient
          id="paint36_linear_107_84227"
          x1="306.566"
          y1="-2.15452"
          x2="309.166"
          y2="7.04741"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F44274" />
          <stop offset="1" stop-color="#E41F9A" />
        </linearGradient>
        <linearGradient
          id="paint37_linear_107_84227"
          x1="276.201"
          y1="39.9271"
          x2="267.002"
          y2="38.7512"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F44274" />
          <stop offset="1" stop-color="#E41F9A" />
        </linearGradient>
        <linearGradient
          id="paint38_linear_107_84227"
          x1="297.286"
          y1="7.18964"
          x2="308.827"
          y2="16.4608"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F44274" />
          <stop offset="1" stop-color="#E41F9A" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default PartyPopper;
